import { useCallback, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API, LOGO_URL } from "@/lib/brand";
import { TOKEN_KEY, errText } from "@/lib/admin";
import { Entries } from "@/components/admin/Entries";

const Login = ({ onToken }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { onToken((await axios.post(`${API}/admin/login`, form)).data.token); }
    catch (ex) { setErr(errText(ex)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-stone-200 rounded-3xl p-9 space-y-5" data-testid="admin-login-form">
        <img src={LOGO_URL} alt="" className="h-28 w-auto mx-auto object-contain" />
        <h1 className="font-serif-display text-3xl text-center">Club admin</h1>
        <div className="space-y-1.5"><Label htmlFor="ae">Email</Label><Input id="ae" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email-input" /></div>
        <div className="space-y-1.5"><Label htmlFor="ap">Password</Label><Input id="ap" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password-input" /></div>
        {err && <p className="text-sm text-red-700" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} className="w-full rounded-full bg-stone-900 text-white py-3.5 hover:bg-amber-600 transition-colors duration-300 flex justify-center gap-2 disabled:opacity-60" data-testid="admin-login-button">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};

export default function Admin() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const save = (t) => { localStorage.setItem(TOKEN_KEY, t); setToken(t); };
  const logout = useCallback(() => { localStorage.removeItem(TOKEN_KEY); setToken(null); }, []);
  return token ? <Entries token={token} onLogout={logout} /> : <Login onToken={save} />;
}
